import React from 'react';
import PropTypes from "prop-types";
import { ProgressSurveyQuestion } from "../utils/types";
import DesktopQuestionDefinitionView from "./DesktopQuestionDefinitionView";
import MobileQuestionDefinitionView from "./MobileQuestionDefinitionView";

export default class QuestionDefinitionView extends React.Component {

  get hasQuestions() {
    return this.props.surveyQuestions && this.props.surveyQuestions.length > 0;
  }

  render() {
    if ( !this.hasQuestions ) return null;
    return (
      <>
        <DesktopQuestionDefinitionView
          surveyQuestions={this.props.surveyQuestions}
          showQuestionDefinitions={this.props.showQuestionDefinitions}
          onClose={this.props.onClose}
        />
        <MobileQuestionDefinitionView
          surveyQuestions={this.props.surveyQuestions}
          open={this.props.showQuestionDefinitions}
          onClose={this.props.onClose}
        />
      </>
    );
  }
}

QuestionDefinitionView.propTypes = {
  surveyQuestions: PropTypes.arrayOf(ProgressSurveyQuestion),
  onClose: PropTypes.func.isRequired,
  showQuestionDefinitions: PropTypes.bool.isRequired
};
